"use strict";
exports.__esModule = true;
exports.PAYMENT_LINK_TYPES = void 0;
var PAYMENT_LINK_TYPES;
(function (PAYMENT_LINK_TYPES) {
    PAYMENT_LINK_TYPES["LINK"] = "LINK";
    PAYMENT_LINK_TYPES["PHONE"] = "PHONE";
})(PAYMENT_LINK_TYPES = exports.PAYMENT_LINK_TYPES || (exports.PAYMENT_LINK_TYPES = {}));
//# sourceMappingURL=payment-links.constants.js.map